var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"upload-label"},[_c('a',{staticClass:"download-link",attrs:{"href":_vm.filePath,"download":""}},[_vm._v("\n    "+_vm._s(_vm.fileName)+"\n  ")]),_vm._v("\n  "+_vm._s(_vm.description)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }